export const DEFAULT_MOVE_SPEED = 500;
export const FAST_MOVE_SPEED = 50;
